import { render } from "./ClientSpaceWalletStake.vue?vue&type=template&id=3c3bf008&scoped=true"
import script from "./ClientSpaceWalletStake.vue?vue&type=script&lang=js"
export * from "./ClientSpaceWalletStake.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=3c3bf008&lang=scss&scoped=true"
import "./custom-clientSpaceWalletStake.scss?vue&type=style&index=1&id=3c3bf008&lang=scss&scoped=true"
import "./ClientSpaceWalletStake.vue?vue&type=style&index=2&id=3c3bf008&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3bf008"]])

export default __exports__